export default "__VITE_ASSET__cVleDe9U__"